import {IRegionAttachment, ISkeletonData} from 'pixi-spine';

export function setupSequenceMeshRegions(spine: ISkeletonData): void {
    spine.skins.forEach((skin) => {
        skin.attachments.forEach(attachmentMap => {
            Object.values(attachmentMap).forEach(attachmentElement => {
                if ((attachmentElement as IRegionAttachment).region === null && attachmentElement.sequence?.regions[0]) {
                    (attachmentElement as IRegionAttachment).region = attachmentElement.sequence.regions[0];
                }
            });
        });
    });
}